






















import Vue from 'vue';
import BannerRight from '@/components/generic/BannerRight.vue';
import BannerLeft from '@/components/generic/BannerLeft.vue';
import ProductBanner from '@/components/generic/ProductBanner.vue';

export default Vue.extend({
  components: {
    BannerRight,
    BannerLeft,
    ProductBanner,
  },
  data: () => ({
    firstButtons: [
      {
        link: { path: 'flow/New%20Customer' },
        text: 'Verify Device',
        color: 'primary',
      },
      {
        link: { path: 'flow/Digital%20Verification' },
        text: 'Verify Consumer & Device',
        color: 'primary',
      },
    ],
    dvButtons: [
      {
        link: { path: 'flow/New%20Customer' },
        text: 'Verify Device',
        color: 'primary',
      },
    ],
    items: [
      {
        route: { path: 'flow/New%20Customer' },
        name: 'Device Reputation and Verification',
        icon: '/img/tu-device.png',
        border: 'primary-bottom',
      },
      {
        route: { path: 'flow/Digital%20Verification' },
        name: 'Consumer (KYC) & Digital Verification',
        icon: '/img/tu-biz.png',
        border: 'secondary-bottom',
      },
      {
        route: { path: 'flow/Fast%20Login' },
        name: 'App Authentication',
        icon: '/img/tu-laptop.png',
        border: 'primary-bottom',
      },
    ],
  }),
});
